import {
  FRENCH_SPEAKING_COUNTRIES,
  GERMAN_SPEAKING_COUNTRIES,
  EMEA_REGION,
  AUSTRALIA_NEW_ZEALAND_REGION,
  AMERICA_REGION,
  SPAIN_ISO2,
  PORTUGAL_ISO2,
  BRAZIL_ISO2,
  LATAM_REGION,
  getContactSalesRegionByCountry
} from "services/countries/countries-service";
import { createPopup } from "@typeform/embed";
import "@typeform/embed/build/css/popup.css";
import { trackEvent } from "/services/bigbrain-service";
import { getCookie } from "/services/cookies-service";
import { BIG_BRAIN_VISITOR_ID } from "/constants/cookies";
import {
  TYPEFORM_CONTACT_SALES_QUESTION_CHANGED,
  TYPEFORM_CONTACT_SALES_FORM_LOADED,
  TYPEFORM_CONTACT_SALES_FORM_SUBMITTED,
  TYPEFORM_CONTACT_SALES_FORM_CLOSED
} from "constants/bigbrain-event-types";
import { leadSourceDefaultValue } from "client/services/hubspot-service/hubspot-constants";

const TYPEFORM_CONTACT_SALES_EMEA_REGION_FORM_ID = "Rb9pva6n";
const TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID = "B91EZP5w";
const TYPEFORM_CONTACT_SALES_GERMAN_FORM_ID = "onptOGWz";
const TYPEFORM_CONTACT_SALES_SPAIN_FORM_ID = "kxf82cwp";
const TYPEFORM_CONTACT_SALES_PORTUGAL_FORM_ID = "tiiFVEDy";
const TYPEFORM_CONTACT_SALES_BRAZIL_FORM_ID = "fcCPz0Z1";
const TYPEFORM_CONTACT_SALES_LATAM_REGION_FORM_ID = "MCW2vdfv";
const TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID = "WYNld7NX";
const TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID = "Fl3WSnnm";
const TYPEFORM_CONTACT_NO_SDR_FORM_ID = "idXP35wo";

// used for testing only
const TEST_TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID = "Qi8VILCS";

const TYPEFORM_CONTACT_SALES_VISITOR_ID_PARAM = "visitor_id";
const TYPEFORM_CONTACT_SALES_COUNTRY_PARAM = "country";
const TYPEFORM_CONTACT_SALES_REGION_PARAM = "region";
const TYPEFORM_CONTACT_SALES_KEEP_SESSION_PARAM = "keepSession";
const TYPEFORM_CONTACT_SALES_DEVICE_PARAM = "Device";
const TYPEFORM_CONTACT_SALES_LEAD_SOURCE_PARAM = "lead_source";

const getTypeformContactSalesFormId = ({ country, region, isTest }) => {
  if (isTest) {
    return TEST_TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID;
  }

  if (FRENCH_SPEAKING_COUNTRIES.includes(country)) return TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID;
  if (GERMAN_SPEAKING_COUNTRIES.includes(country)) return TYPEFORM_CONTACT_SALES_GERMAN_FORM_ID;
  if (country === SPAIN_ISO2) return TYPEFORM_CONTACT_SALES_SPAIN_FORM_ID;
  if (country === PORTUGAL_ISO2) return TYPEFORM_CONTACT_SALES_PORTUGAL_FORM_ID;
  if (country === BRAZIL_ISO2) return TYPEFORM_CONTACT_SALES_BRAZIL_FORM_ID;

  switch (region) {
    case EMEA_REGION:
      return TYPEFORM_CONTACT_SALES_EMEA_REGION_FORM_ID;
    case AUSTRALIA_NEW_ZEALAND_REGION:
      return TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID;
    case AMERICA_REGION:
      return TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID;
    case LATAM_REGION:
      return TYPEFORM_CONTACT_SALES_LATAM_REGION_FORM_ID;
    default:
      return TYPEFORM_CONTACT_NO_SDR_FORM_ID;
  }
};

export const TYPEFORM_DESKTOP_DEVICE_TYPE = "Desktop";
export const TYPEFORM_MOBILE_DEVICE_TYPE = "Mobile";

export const openContactSalesTypeForm = ({ country, deviceType, isTest = false }) => {
  const region = getContactSalesRegionByCountry(country);
  const formId = getTypeformContactSalesFormId({ country, region, isTest });
  // fire AB test
  const visitorId = getCookie(BIG_BRAIN_VISITOR_ID) || "";
  const { toggle } = createPopup(formId, {
    onQuestionChanged: (data) => {
      trackEvent(TYPEFORM_CONTACT_SALES_QUESTION_CHANGED, {
        kind: data?.ref,
        info1: formId
      });
    },
    onSubmit: (data) => {
      trackEvent(TYPEFORM_CONTACT_SALES_FORM_SUBMITTED, {
        kind: data?.responseId,
        info1: formId
      });
    },
    onReady: () => {
      trackEvent(TYPEFORM_CONTACT_SALES_FORM_LOADED, { info1: formId });
    },
    onClose: () => {
      trackEvent(TYPEFORM_CONTACT_SALES_FORM_CLOSED, { info1: formId });
    },
    hidden: {
      [TYPEFORM_CONTACT_SALES_REGION_PARAM]: region,
      [TYPEFORM_CONTACT_SALES_COUNTRY_PARAM]: country,
      [TYPEFORM_CONTACT_SALES_KEEP_SESSION_PARAM]: "true",
      [TYPEFORM_CONTACT_SALES_VISITOR_ID_PARAM]: visitorId,
      [TYPEFORM_CONTACT_SALES_DEVICE_PARAM]: deviceType,
      [TYPEFORM_CONTACT_SALES_LEAD_SOURCE_PARAM]: leadSourceDefaultValue
    }
  });
  toggle();
};
